import React from "react";
import PropTypes from "prop-types";
import TextField from "./TextField";

const DatePicker = props => <TextField type="date" {...props} />;

DatePicker.propTypes = {
    storeName: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
        PropTypes.bool,
        PropTypes.arrayOf,
    ]).isRequired,
    onChange: PropTypes.func.isRequired,
};

export default DatePicker;
